export default {
    goEasy: null
}